import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import PageWrapper from "../SignupPages/PageWrapper";
import ProgressBar from "../../components/ProgressBarWithBackArrow/ProgressBarWithBackArrow";
import "../SignupPages/SignupCommon.css";

const NadPlusPage11: React.FC = () => {
  const [selectedOption, setSelectedOption] = useState<string>("");
  const navigate = useNavigate();

  useEffect(() => {
    const step10Completed = localStorage.getItem("completed-step-10");
    if (step10Completed) {
      navigate("/nadplus/getting-started/step-11", { replace: true });
    } else {
      navigate("/nadplus/getting-started/step-10", { replace: true });
    }
  }, []);

  const handleOptionClick = (option: string) => {
    setSelectedOption(option);

    localStorage.setItem(
      "Do_you_have_any_past_trauma_or_conditions_that_would_affect_your_ability_to_use_a_nasal_spray",
      JSON.stringify({
        key: "Do_you_have_any_past_trauma_or_conditions_that_would_affect_your_ability_to_use_a_nasal_spray",
        value: option,
      })
    );
    localStorage.setItem("completed-step-11", "true");

    setTimeout(() => {
    navigate("/nadplus/getting-started/step-12");
  }, 1000); 
  };

  useEffect(() => {
    const saved = localStorage.getItem(
      "Do_you_have_any_past_trauma_or_conditions_that_would_affect_your_ability_to_use_a_nasal_spray"
    );
    if (saved) {
      const parsed = JSON.parse(saved);
      setSelectedOption(parsed.value);
    }
  }, []);

  const handleBack = () => {
    navigate("/nadplus/getting-started/step-10");
  };

  return (
    <PageWrapper>
      <div className="signup-page-container container">
        <ProgressBar progress={88} onBack={handleBack} />
        <div className="signup-content">
          <p className="signup-intro">
            Do you have any past trauma or conditions that would affect your ability to use a nasal spray?
          </p>
          <div className="options options-box">
            <label
              className={selectedOption === "Yes" ? "selected" : ""}
              onClick={() => handleOptionClick("Yes")}
            >
              Yes
            </label>
            <label
              className={selectedOption === "No" ? "selected" : ""}
              onClick={() => handleOptionClick("No")}
            >
              No
            </label>
          </div>
        </div>
      </div>
    </PageWrapper>
  );
};

export default NadPlusPage11;